import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PensionArrangementValuation } from '../../Models/Models/Account/PensionArrangementValuation';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionArrangementValuationsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, shouldAdjustRoundingForDisplay: boolean): Promise<Array<PensionArrangementValuation>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/PensionArrangementValuations/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, shouldAdjustRoundingForDisplay: shouldAdjustRoundingForDisplay }

    return AjaxWrapper.get<Array<PensionArrangementValuation>, any>(url, data);
  }
}

